(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !window.DesignMode) return;
  try {
    

$(document).ready(function () {

  let dataTarget = $(".carousel").attr("id");
  let firstHref;

  $(`#${dataTarget}.carousel .item`).each(function (index) {
      // prev
      if(index===0) 
      {
        firstHref = $(this).children(":first-child").attr("href");
      } 
      $(this).children(":first-child")
          .removeAttr("href")
          .attr("data-slide","prev")
          .attr("data-target", "#"+dataTarget)
      // main
      let next = $(this).next();
      if (!next.length) {
          next = $(this).siblings().first();
          next.children(":first-child").attr("href",firstHref);
      }
      next.children(':first-child')
          .clone()
          .removeAttr("data-slide")
          .appendTo($(this))
      // next
      if (next.next().length > 0) { 
          next.next()
              .children(':first-child')
              .clone()
              .removeAttr("href")
              .attr("data-slide","next")
              .attr("data-target", "#"+dataTarget)
              .appendTo($(this))
      } else {
          $(this).siblings(':first')
              .children(':first-child')
              .clone()
              .removeAttr("href")
              .attr("data-slide","next")
              .attr("data-target", "#"+dataTarget)
              .appendTo($(this))
      }
  });
  
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-template"]) return;
  try {
    

  $(document).ready(function(){
    const askImages = $(".pValue.callImageCreator");
    const askIt = (data, type="tee") => {
      data = data.replace(/(\r\n|\n|\r)/gm," ").toLowerCase();
      $.ajax({
        method: 'POST',
        url: 'https://us-central1-hosting-loomstate.cloudfunctions.net/cmg-customizer-creation-storage-prod',
        data: { data: data[0].toUpperCase() + data.slice(1), type:type},
        crossDomain: true,
        dataType: "json"
      });
    }
    if(askImages){
      for(let i = 0 ; i < askImages.length; i++){
        const type = askImages[i].dataset.type;
        console.log(type);
        askIt(askImages[i].innerText, type);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  function collapseMenuOnMobile () {
    if($(window).width() < 750){
       $("#mainMenu li").removeClass("expanded");
      }else{
      $("#mainMenu li.active").addClass("expanded");
    }
  }
  $("#mainMenu ol li").click(function(e){
    e.stopPropagation();
    const li = $(this);
    if(li.hasClass("expanded")){
      li.children("ol").slideUp("fast",e=>{li.removeClass("expanded")});
    }else{
      li.children("ol").slideDown("fast",e=>{li.addClass("expanded")});
    }
  });

  // endelss scroll
  let alreadyDoingIt = false;
  function infiniteScroll() {
    if(alreadyDoingIt || $("#more>a").length === 0) return null;

    alreadyDoingIt = true;
    const link = $('#more a').attr("href")
    $.ajax({
      type: 'GET',
      url: link,
      beforeSend: function () {
        $("#more a").text("Loading ...");
      },
      success: function(data) {
        // remove loading feedback
        const filteredData = $(data).find(".grid__item.grid__item--collection-template");
        const newLink = $(data).find("#more a").attr("href");
        if(newLink)
          $("#more a").attr("href",newLink).text("Load more");
        else
          $("#more a").remove();

        for(let i = 0; i < filteredData.length ; i++){
            $(filteredData[i]).css({opacity:0}).appendTo($(".grid.grid--uniform.grid--view-items")).animate({opacity: 1},200);
        }
        alreadyDoingIt = false
      }
    });
  }

  $(document).ready(function () {
    $("#more>a").click(function(e){
      e.preventDefault();
      infiniteScroll();
    });
    collapseMenuOnMobile();
  });
  $(window).resize(function() {
    collapseMenuOnMobile();
  });
  $(window).scroll(function() {
    if($("#more").length > 0){
      const top_of_element = $("#more").offset().top;
      const bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();

      if ( bottom_of_screen > top_of_element ){
        infiniteScroll()
      }
    }
  });

  $('#categorySelection').change(function () {
     var url = $(this).find("option:selected").val();
     window.location.href = url;
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  $(document).ready(function () {
    $('#sidebarCollapse').on('click', function () {
        $('#sidebar').addClass('active');
        $('a[aria-expanded=true]').attr('aria-expanded', 'false');
    });
    $('#dismiss, .overlay').on('click', function () {
        $('#sidebar').removeClass('active');
        $('.overlay').fadeOut();
    });
  });

  (async function ticker(tickerIndex = -1) {
    const items = $(".ticker-item");
    const settings = $("#headerTicker").data();
    if (items.length === 0) return;
    const next = tickerIndex >= items.length -1 ? 0 : tickerIndex+1;
    await items.fadeOut(settings.animationDuration).promise();
    await items.eq(next).fadeIn(settings.animationDuration).promise();
    if (tickerIndex === next || items.length === 1) return;
    setTimeout(function(){ticker(next)}, settings.duration * 1000);
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal"] && !window.DesignMode) return;
  try {
    

$(document).ready(function(){

  // get parameters
  const { 
    componentid,
    header, 
    description, 
    placeholder, 
    buttontext, 
    footnotetext, 
    footnotelink,
    footnotelinktext,
    popdelay,
    closeimage,
    display
  } = $(".dg-modal").data();

  // create dom elements
  const overlay = $("<div/>",{"class":"dg-overlay"}).prependTo("body"), 
        modal = $("<div/>",{"class":"dg-modal"}).attr("role","dialog").attr("aria-labeledby","t"+componentid).appendTo(overlay),
        h1__header = $("<h1/>").attr("id","t"+componentid).text(typeof header!=="undefined"?header:null).appendTo(modal),
        form_inputcode = $("<form/>").appendTo(modal),
        label__inputcode = $("<label/>").appendTo(form_inputcode),
        span__inputcodetext = $("<span/>").text(typeof description!=="undefined"?description:null).appendTo(label__inputcode),
        input__entercode = $("<input/>",{"placeHolder":typeof placeholder!=="undefined"?placeholder:null}).appendTo(label__inputcode),
        button__submit = $("<button/>",{"type":"submit"}).text(typeof buttontext!=="undefined"?buttontext:null).appendTo(form_inputcode),
        p__footnote = footnotetext == "" || $("<p/>").text(typeof footnotetext!=="undefined"?footnotetext:null + " ").appendTo(modal),
        a__footnotelink = footnotetext == "" || $("<a/>",{"href":typeof footnotelink!=="undefined"?footnotelink:null}).text(typeof footnotelinktext!=="undefined"?footnotelinktext:null).appendTo(p__footnote),
        a__closemodallink = $("<a/>",{"class":"dg-close-modal", "href":"#"}).html("<img src='"+closeimage+"' alt='close'/>").appendTo(modal);

  const close = ()=>{
    overlay.fadeOut().promise().done(e=>e.fadeOut()); 
  } 

  // modal end
  $(".dg-modal > form").submit(function(e){
    e.preventDefault();
    close();
  });
  $(".dg-close-modal").click(function(e){
    e.preventDefault();
    close();
  });

  // check display
  if( display === "show" && window.localStorage.getItem(`modal-${componentid}`) !== "shown" ) {
    setTimeout(e=>{ overlay.fadeIn() }, (typeof popdelay!=="undefined" ? popdelay : 0) * 1000);
    window.localStorage.setItem(`modal-${componentid}`,"shown")
  }
  
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-content"]) return;
  try {
     
$( document ).ready(function() {
	$(".js-modal-open-login-modal").click();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  $(document).ready(function(){
    // make sure links opne in new window
    $('.product-single__description a[href^="http"]').not('a[href^="{{ shop.url }}"]').attr('target', '_blank');
    $(".swatch-element input").change(function(){
      const optionGroup = $(this).data("index").replace("option","") - 1;
      const optionValue = $(this).val();
      const header = $(`.swatch[data-option-index=${optionGroup}] > .header > span`);
      header.text(optionValue)
    })
    $(".swatch-element input:checked").each(function(){
      const optionGroup = $(this).data("index").replace("option","") - 1;
      const optionValue = $(this).val();
      const header = $(`.swatch[data-option-index=${optionGroup}] > .header > span`);
      header.text(optionValue)
    })
  })
  // custom text
  const custom = {
    settings: {
      lineCharLimit: 12,
      inputClass: ".customInput",
      textarea: ".webyze-infinitelivepreviewoptions-form textarea",
      linkInput: ".webyze-infinitelivepreviewoptions-form input",
      originalWraper: ".webyze-ilpo-preview-wrapper",
      imagesWrapper: ".grid__item product-single__media-group",
      imageWraper: ".product-single__media-wrapper"
    },
    printCanvas:null,
    updateText: function () {
      // get text from inputs
      const textarea = $(this.settings.textarea);
      const linkInput = $(this.settings.linkInput);
      const newText = this.formatText(this.getTextFromInputs(this.settings.inputClass));
      // update artwork text and link
      textarea.val(newText);
      linkInput.val(this.createLink(newText));
    },
    getTextFromInputs: function (selector) {
      let fields = [];
      const inputs = $(selector);
      inputs.map(input=>{
        switch(inputs[input].type){
          case "checkbox":
            if(inputs[input].checked === true) fields.push({name: inputs[input].name, value: inputs[input].value});
            break;
          default:
            const checkMultiple =  inputs[input].value.split(", ");
            if(checkMultiple.length > 1) {
              checkMultiple.map(option => {
                if(option!=="") fields.push({name: inputs[input].name, value: option});
              });
            } else {
              if(inputs[input].value!=="") fields.push({name: inputs[input].name, value: inputs[input].value});
            }
            break;
        }
      });
      return fields
    },
    createLink: function (text) {
      const type = $("#customOrderTee").attr("data-type");
      return "https://storage.googleapis.com/loomstate-media-storage-prod/v4" + type + "-" + text.replace(/[ .,&\n]/g, "").toLowerCase() + ".png";
    },
    formatText: function (inputs) {
      let size = inputs.length;
	  let fistNotPrimary = 0;

      let outputString=[];

      for (let i = 0 ; i < size ; i++) {
		if(["properties[Protein]","properties[Rice]","properties[Beans]"].includes(inputs[i].name)){
			outputString.push(inputs[i].value);
		}else{
			if(fistNotPrimary===0){
				outputString.push(inputs[i].value);
				fistNotPrimary++;
                continue;
			}

			let pre="";
			if(i+1<size)
				pre=", ";
			if(i+1===size)
				pre=" & ";

			if(outputString[outputString.length-1].length +inputs[i].value.length + pre.length >14||outputString[outputString.length-1].length==0)
				outputString.push(inputs[i].value)
			else{
				outputString[outputString.length-1]+=pre+inputs[i].value;

			}
            fistNotPrimary++;
		}
	  }

	  let finalSlogan = outputString[0];
	  size = outputString.length;

	  for (let i = 1 ; i <size; i++) {
		if(i+1==size && (!outputString[i].includes(",")&&!outputString[i].includes("&"))){
			finalSlogan+=" &\n"+outputString[i];
			continue;
		}
  		if(i+1<size || fistNotPrimary >1)
			finalSlogan+=",\n"
		if(i+1===size && fistNotPrimary<=1)
			finalSlogan+=" &\n"

		finalSlogan+=outputString[i];
	  }

      return finalSlogan.charAt(0).toUpperCase() + finalSlogan.slice(1)+".";

    },

    tryFindMovePreviewer : function () {
      const selector = $(this.settings.originalWraper);
      const contatiner = $(this.settings.imageWraper);
      let isthere = selector.length !== 0 ? true : false;
      if(!isthere){
        setTimeout(()=>{
          this.tryFindMovePreviewer()
        },500)
      }else{
        selector.css({display:"none"}).appendTo(contatiner[0]).fadeIn();
      }
    },
    updatePrintCanvas: function () {
      // if canvas doesnt exist create it
      if( typeof this.printCanvas === "undefined"){
        this.printCanvas = $("<canvas/>");
        $("body").append(this.printCanvas)
      }
    },
    init: function () {
      this.tryFindMovePreviewer();
      $(this.settings.inputClass).change(e=>{
        this.updateText();
        this.updatePrintCanvas();
      });
    }
  };
  if($("#customOrderTee").length === 1){
    custom.init();
  }

  } catch(e) { console.error(e); }
})();
})();
